export const getTextFromHtmlString = (htmlString: string | undefined) => {
  if (!htmlString) return;
  const div = document.createElement('div');
  div.innerHTML = htmlString;
  const text = `${div.innerText.substring(0, 161).trim()}...`;
  div.remove();
  return text;
};
